import { Button, Img, Text, TextWithIcon } from "ui-kit/components-branded/index"
import { useBookingContext } from "modules/Booking/BookingContext"

export function RequestTime() {
    const [, { toggleTimeRequestModalActive }] = useBookingContext()

    function handleClickButton() {
        toggleTimeRequestModalActive(true)
    }

    return (
        <div className="request-time is-flex is-justify-content-space-between ">
            <div className="request-time__text">
                <TextWithIcon
                    icon={<Img className="request-time__emoji" src="alarm-clock-emoji.png" />}
                    position="left"
                    isAccent
                >
                    Нет удобного времени?
                </TextWithIcon>
                <Text className="is-block">Запросите любое подходящее вам время для сессии.</Text>
            </div>
            <Button onClick={handleClickButton}>Запросить время</Button>
        </div>
    )
}
